module.exports = __webpack_public_path__ + "static/media/awardsbackground.d9226b9b.jpg";